var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlimitedCreativity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 287,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#111111",
    d: "m187.668,10.0269l0,45.0315c0,23.4947 -14.562,38.7908 -36.343,38.7908c-22.271,0 -37.2,-15.2961 -37.2,-38.7908l0,-45.0315l20.19,0l0,45.0315c0,12.4816 6.731,20.1908 17.01,20.1908c9.667,0 16.152,-7.7092 16.152,-20.1908l0,-45.0315l20.191,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#111111",
    d: "m239.67,28.7492c14.317,0 23.862,10.1566 23.862,25.575l0,37.6895l-19.457,0l0,-33.529c0,-7.2197 -4.283,-12.1144 -10.524,-12.1144c-7.709,0 -12.726,5.2618 -12.726,17.1315l0,28.5119l-19.579,0l0,-61.429l19.579,0l0,5.8737c4.65,-4.8947 11.136,-7.7092 18.845,-7.7092z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#111111",
    d: "m296.469,92.0137l-19.579,0l0,-88.10525l19.579,0l0,88.10525z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#111111",
    d: "m331.266,92.0137l-19.578,0l0,-61.429l19.578,0l0,61.429z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#111111",
    d: "m425.979,28.7492c13.093,0 23.494,9.9119 23.494,24.8408l0,38.4237l-19.456,0l0,-34.2632c0,-6.975 -4.528,-11.3802 -10.279,-11.3802c-7.22,0 -11.992,5.2618 -11.992,15.5407l0,30.1027l-19.579,0l0,-34.2632c0,-6.975 -4.528,-11.3802 -10.402,-11.3802c-7.097,0 -11.747,5.2618 -11.747,15.5407l0,30.1027l-19.579,0l0,-61.429l19.579,0l0,5.629c4.161,-4.65 10.157,-7.4645 18.111,-7.4645c8.565,0 15.908,3.6711 20.068,10.4013c4.895,-6.3631 12.237,-10.4013 21.782,-10.4013z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#111111",
    d: "m483.39,92.0137l-19.579,0l0,-61.429l19.579,0l0,61.429z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#111111",
    d: "m539.557,73.9031l4.527,15.4185c-4.772,2.5697 -9.789,4.5276 -16.764,4.5276c-15.296,0 -24.474,-8.3211 -24.474,-24.4737l0,-23.25l-11.135,0l0,-15.5408l11.135,0l0,-18.1105l19.579,0l0,18.1105l18.111,0l0,15.5408l-18.111,0l0,21.2921c0,6.3632 3.059,8.9329 8.199,8.9329c2.692,0 6.363,-0.9789 8.933,-2.4474z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "#111111",
    d: "m610.512,61.2992l0,5.0171l-45.032,0c1.591,7.3421 6.608,11.8697 13.216,11.8697c4.528,0 9.79,-1.1013 13.094,-7.0973l17.376,3.5487c-5.262,12.971 -16.397,19.2118 -30.47,19.2118c-17.743,0 -32.427,-13.0934 -32.427,-32.55c0,-19.3342 14.684,-32.55 32.55,-32.55c17.376,0 31.326,12.4816 31.693,32.55zm-31.693,-16.6421c-5.507,0 -11.136,3.4263 -12.971,9.6671l25.33,0c-1.836,-6.6079 -6.73,-9.6671 -12.359,-9.6671z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fill: "#111111",
    d: "m685.303,3.90845l0,88.10525l-19.579,0l0,-4.8948c-4.772,4.2829 -11.135,6.7303 -19.089,6.7303c-16.275,0 -29.981,-13.0934 -29.981,-32.55c0,-19.3342 13.706,-32.55 29.981,-32.55c7.954,0 14.317,2.4474 19.089,6.7303l0,-31.57105l19.579,0zm-34.63,73.29865c7.954,0 15.051,-6.3632 15.051,-15.9079c0,-9.4224 -7.097,-15.9079 -15.051,-15.9079c-8.566,0 -14.807,6.4855 -14.807,15.9079c0,9.5447 6.241,15.9079 14.807,15.9079z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    fill: "#111111",
    d: "m159.507,179.752l19.823,3.915c-3.793,20.558 -20.313,32.55 -41.36,32.55c-24.352,0 -43.5635,-18.722 -43.5635,-42.828c0,-23.985 19.2115,-42.829 43.5635,-42.829c20.19,0 37.322,11.992 41.238,31.448l-19.824,4.65c-2.57,-11.869 -10.891,-17.621 -21.414,-17.621c-12.971,0 -23.373,10.402 -23.373,24.352c0,13.949 10.402,24.473 23.373,24.473c10.401,0 18.722,-5.874 21.537,-18.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    fill: "#111111",
    d: "m231.419,152.096c1.713,0 2.937,0.123 4.405,0.49l-0.856,19.579l-3.549,0c-13.705,0 -21.17,7.097 -21.17,23.005l0,19.212l-19.579,0l0,-61.429l19.579,0l0,11.747c4.405,-7.342 11.136,-12.604 21.17,-12.604z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    fill: "#111111",
    d: "m303.934,183.667l0,5.018l-45.032,0c1.591,7.342 6.608,11.869 13.216,11.869c4.528,0 9.789,-1.101 13.093,-7.097l17.377,3.549c-5.262,12.971 -16.398,19.211 -30.47,19.211c-17.743,0 -32.428,-13.093 -32.428,-32.55c0,-19.334 14.685,-32.55 32.55,-32.55c17.377,0 31.327,12.482 31.694,32.55zm-31.694,-16.642c-5.506,0 -11.135,3.427 -12.971,9.667l25.331,0c-1.836,-6.607 -6.731,-9.667 -12.36,-9.667z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    fill: "#111111",
    d: "m378.725,152.953l0,61.429l-19.579,0l0,-4.895c-4.773,4.283 -11.136,6.73 -19.09,6.73c-16.275,0 -29.98,-13.093 -29.98,-32.55c0,-19.334 13.705,-32.55 29.98,-32.55c7.954,0 14.317,2.448 19.09,6.731l0,-4.895l19.579,0zm-34.631,46.622c7.954,0 15.052,-6.363 15.052,-15.908c0,-9.422 -7.098,-15.907 -15.052,-15.907c-8.565,0 -14.806,6.485 -14.806,15.907c0,9.545 6.241,15.908 14.806,15.908z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    fill: "#111111",
    d: "m433.858,196.271l4.528,15.419c-4.772,2.57 -9.789,4.527 -16.764,4.527c-15.296,0 -24.474,-8.321 -24.474,-24.473l0,-23.25l-11.136,0l0,-15.541l11.136,0l0,-18.111l19.579,0l0,18.111l18.11,0l0,15.541l-18.11,0l0,21.292c0,6.363 3.059,8.933 8.199,8.933c2.692,0 6.363,-0.979 8.932,-2.448z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    fill: "#111111",
    d: "m466.362,214.382l-19.579,0l0,-61.429l19.579,0l0,61.429z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    fill: "#111111",
    d: "m546.145,152.831l-25.453,61.551l-19.946,0l-25.453,-61.551l20.681,0l14.806,37.934l14.685,-37.934l20.68,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    fill: "#111111",
    d: "m574.629,214.382l-19.579,0l0,-61.429l19.579,0l0,61.429z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    fill: "#111111",
    d: "m630.795,196.271l4.528,15.419c-4.773,2.57 -9.79,4.527 -16.765,4.527c-15.296,0 -24.473,-8.321 -24.473,-24.473l0,-23.25l-11.136,0l0,-15.541l11.136,0l0,-18.111l19.579,0l0,18.111l18.11,0l0,15.541l-18.11,0l0,21.292c0,6.363 3.059,8.933 8.198,8.933c2.692,0 6.363,-0.979 8.933,-2.448z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    fill: "#111111",
    d: "m708.697,152.831l-35.487,82.354l-21.17,0l9.912,-22.883l-25.452,-59.471l21.047,0l14.562,35.854l15.541,-35.854l21.047,0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_20",
    fill: "#E35019",
    ry: 12.0822,
    rx: 11.9146,
    cy: 134.439,
    cx: 457.102
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_21",
    fill: "#FACA15",
    ry: 12.0822,
    rx: 11.9146,
    cy: 134.439,
    cx: 565.194
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_22",
    fill: "#0BB3F0",
    ry: 12.0748,
    rx: 11.9073,
    cy: 12.1322,
    cx: 473.563
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_23",
    fill: "#FACA15",
    ry: 12.0748,
    rx: 11.9073,
    cy: 12.1322,
    cx: 321.716
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlimitedCreativity);
export default __webpack_public_path__ + "static/media/unlimited-creativity.3caa195f9b6854e5ad5ee136f2f0d2e5.svg";
export { ForwardRef as ReactComponent };